module.exports = __webpack_public_path__ + "static/media/icon-piece-1.cf216427.png";